// extracted by mini-css-extract-plugin
module.exports = {"ThreeColumnRank":"ThreeColumnRank--2glTP","icon":"icon--2Y0U0"};